export enum WaitingRoomState {
  AWAITING_ADMISSION = 'AWAITING_ADMISSION',
  ADMITTED = 'ADMITTED',
}
